import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/medsafe-logo.png'


const _hoisted_1 = { class: "flex justify-center" }


import { storeToRefs } from 'pinia';
import { defineComponent, ref, onMounted } from 'vue';
// eslint-disable-next-line import/no-cycle
import { useAuthStore } from '@/store/auth/authModule';
import { useRouterStore } from '@/store/router/routerModule';
import AppSelector from '@/components/AppSelector.vue';

const __default__ = { name: 'AppListView' };

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

onMounted(async () => {
  console.log('AppListView mounted');
  apps.value = await useRouterStore().getAppList();
});

const apps = ref<any[]>([]);
const store = useAuthStore();
const { getAvailableApps } = storeToRefs(store);

// const goToLKTest = () => {
//   window.open('https://ecohospital.ru/redirect-login', '_blank');
// };
// const goToDevPro = () => {
//   window.open('https://dev.medsafe.pro/redirect-login', '_blank');
// };
// const goToDevDoctor = () => {
//   window.open('https://dev.medsafe.doctor/#/redirect-login', '_blank');
// };

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_img, {
          src: _imports_0,
          width: "200px",
          class: "q-mt-lg"
        })
      ]),
      (apps.value.length)
        ? (_openBlock(), _createBlock(AppSelector, {
            key: 0,
            apps: apps.value
          }, null, 8, ["apps"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})